
import React from 'react';
import { motion } from "framer-motion";
import SolutionsHeader from "@/components/solutions/SolutionsHeader";
import SolutionCard from "@/components/solutions/SolutionCard";
import Subscribe from "@/components/Subscribe";
import solutions from "@/data/solutionsData";

const Solutions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-white dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-16">
        <SolutionsHeader />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <SolutionCard 
              key={solution.id} 
              solution={solution} 
              index={index} 
            />
          ))}
        </div>
        
        <div className="curved-xl bg-white dark:bg-gray-800 p-8 shadow-soft">
          <Subscribe />
        </div>
      </div>
    </div>
  );
};

export default Solutions;
